import { BaseRestDataProvider } from './BaseRestDataProvider';
import { FiscalYear } from '../models/FiscalYear';

export interface FiscalYearClosingStatus {
  isAlreadyClosed: boolean;
  hasClosingEntries: boolean;
  allVatReturnsBooked: boolean;
  unbookedVatQuarters: string[];
  allFixedAssetsBooked: boolean;
  unbookedFixedAssetCount: number;
  allDepreciationsBooked: boolean;
  missingDepreciationAssets: string[];
  allSupplierInvoicesBooked: boolean;
  unbookedSupplierInvoiceCount: number;
  isBalanced: boolean;
  balanceDiff: number;
  nettoresultaatPreview: number;
  /** Net debit balance of PriveOpnames (0702) for this fiscal year. Positive = owner withdrew. */
  priveOpnamesAmount: number;
  /** Net credit balance of PriveStorting (0701) for this fiscal year. Positive = owner deposited. */
  priveStortingenAmount: number;
}

export class FiscalYearRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/fiscal-years');
  }

  getAll(): Promise<FiscalYear[]> {
    return this.get<FiscalYear[]>(``);
  }

  getById(id: string): Promise<FiscalYear> {
    return this.get<FiscalYear>(`/${id}`);
  }

  add(fiscalYear: FiscalYear): Promise<FiscalYear> {
    return this.post<FiscalYear>(``, fiscalYear);
  }

  update(id: string, fiscalYear: FiscalYear): Promise<void> {
    return this.put<void>(`/${id}`, fiscalYear);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }

  getClosingStatus(id: string): Promise<FiscalYearClosingStatus> {
    return this.get<FiscalYearClosingStatus>(`/${id}/closing-status`);
  }

  closeFiscalYear(id: string): Promise<void> {
    return this.postVoid(`/${id}/close`);
  }

  uncloseFiscalYear(id: string): Promise<void> {
    return this.postVoid(`/${id}/unclose`);
  }
}

export type { FiscalYear };
